import { render, staticRenderFns } from "./BatchImport.vue?vue&type=template&id=6c454b10&scoped=true"
import script from "./BatchImport.vue?vue&type=script&lang=js"
export * from "./BatchImport.vue?vue&type=script&lang=js"
import style0 from "./BatchImport.vue?vue&type=style&index=0&id=6c454b10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c454b10",
  null
  
)

export default component.exports